import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import type { Props } from './model/types.tsx';
import rootEpic from './ops/index.tsx';
import { setBaseUrl } from './services/index.tsx';
import { setAppProps } from './state/actions.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class CreateComponentModal extends Component<Props> {
	static defaultProps = {
		projectDefaultAssignee: undefined,
		projectLead: undefined,
	};

	constructor(props: Props) {
		super(props);

		// @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
		this.store = createStore(rootEpic);
		this.initializeProps(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		this.initializeProps(nextProps);
	}

	initializeProps(props: Props) {
		this.store.dispatch(setAppProps(props));
		setBaseUrl(props.baseUrl);
	}

	store: Store<State>;

	render() {
		return (
			<AppBase store={this.store}>
				<ReportErrors
					id="unhandled"
					packageName="jiraProjectDirectoriesComponents"
					teamName="morphinecake"
					sendToPrivacyUnsafeSplunk
				>
					<AppStyle>
						<View />
					</AppStyle>
				</ReportErrors>
			</AppBase>
		);
	}
}
